module.exports = __webpack_public_path__ + "img/E0A9.08760800.svg";